import { decryptData } from "./cryptoHelper";


// ✅ Retrieve decrypted user permissions
export function getUserPermissions() {
  const encrypted =
    localStorage.getItem("userPermissions") ||
    sessionStorage.getItem("userPermissions");

  if (!encrypted) return [];

  return decryptData(encrypted);
}

// ✅ Get all permissions for a module
export function getModulePermissions(moduleName) {
  const permissions = getUserPermissions();
  const module = permissions.find(
    (m) => m.ModuleName.toLowerCase() === moduleName.toLowerCase()
  );
  if (!module) return null;

  return {
    ViewModule: module.ViewModule,
    AddModule: module.AddModule,
    EditModule: module.EditModule,
    DeleteModule: module.DeleteModule,
  };
}

// ✅ Check a specific permission (optional)
export function hasPermission(moduleName, permissionType) {
  const modulePerms = getModulePermissions(moduleName);
  if (!modulePerms) return false;

  switch (permissionType.toLowerCase()) {
    case "view":
      return modulePerms.ViewModule === 1;
    case "add":
      return modulePerms.AddModule === 1;
    case "edit":
      return modulePerms.EditModule === 1;
    case "delete":
      return modulePerms.DeleteModule === 1;
    default:
      return false;
  }
}



  